import { useMatches } from '@tanstack/react-router'
import { useMemo } from 'react'

import type { RouteOrgSiteParams } from './resolveActiveOrgSite'

/**
 * Reads one path param from the matched routes, deepest match first. Each
 * select returns a primitive, so the result is stable across renders.
 */
function useRouteParam(name: keyof RouteOrgSiteParams): string | undefined {
  return useMatches({
    select: (matches) =>
      [...matches]
        .reverse()
        .map((match): unknown => {
          const params: Readonly<Record<string, unknown>> = match.params
          return params[name]
        })
        .find((value): value is string => typeof value === 'string'),
  })
}

/** Org and site ids named in the matched route path. Does not need Rolodex. */
export function useRouteOrgSiteParams(): RouteOrgSiteParams {
  const orgOrSiteID = useRouteParam('orgOrSiteID')
  const siteID = useRouteParam('siteID')
  const orgID = useRouteParam('orgID')

  return useMemo(
    () => ({ orgOrSiteID, siteID, orgID }),
    [orgOrSiteID, siteID, orgID]
  )
}
